/*------------------------------------*\
	#INTERACTION IMAGE
\*------------------------------------*/

window.addEventListener('DOMContentLoaded', (event) => {
	init();
});

window.onresize = interactiveImageResizing;

function init() {
	const dots = document.querySelectorAll('.js-interaction-image-dot'),
		image = document.querySelector('.js-interaction-image');

	if(image) {
		const imageBoundings = image.getBoundingClientRect();

		for (let x = 0; x < dots.length; x++) {
			const modal = dots[x].querySelector('.js-interaction-image-modal'),
				modalClose = dots[x].querySelector('.js-interaction-image-modal-close'),
				modalBoundings = modal.getBoundingClientRect(),
				dotBoundings = dots[x].getBoundingClientRect(),
				dotTitleElement = dots[x].querySelector('.js-interaction-image-dot-label'),
				dotTitleBoundings = dotTitleElement.getBoundingClientRect();

			// Move modal lower when it's not enough space on top of it
			if (modalBoundings.top < 0) {
				modal.style.bottom = modalBoundings.top + 'px';
			}

			if (dotTitleBoundings.right >= imageBoundings.width) {
				// Move dot title to left when it falls out on the right side
				dotTitleElement.style.transform = 'translate(-' + (dotTitleBoundings.width - 10) + 'px, -100%)';
			} else if (dotTitleBoundings.left <= 0) {
				// Move dot title to right when it falls out on the left side
				dotTitleElement.style.transform = 'translate(-' + dotBoundings.left + 'px, -100%)';
			} else {
				dotTitleElement.style.transform = 'translate(-50%, -100%)';
			}

			dots[x].addEventListener('click', function (event) {
				let modals = document.querySelectorAll('.js-interaction-image-modal'),
					dotBoundings = event.target.getBoundingClientRect(),
					modalSpaceLeftOnRightSide = imageBoundings.width - dotBoundings.x,
					modalWidth = 390;

				// Close all open dot modals
				for (let i = 0; i < modals.length; i++) {
					modals[i].classList.add('is-hidden');
				}

				// Show dot modal
				event.target.nextElementSibling.classList.toggle('is-hidden');

				// In case there is not enough space on the right than open it to the left
				if (modalSpaceLeftOnRightSide <= modalWidth) {
					event.target.nextElementSibling.classList.add('is-position-left');
				} else {
					event.target.nextElementSibling.classList.remove('is-position-left');
				}

			});

			modalClose.addEventListener('click', function (event) {
				event.stopPropagation();
				event.target.parentElement.classList.add('is-hidden');
			});
		}
	}
}

function interactiveImageResizing() {
	const imageWrap = document.querySelector('.js-interaction-image-wrap');

	if(imageWrap) {
		imageWrap.style.paddingBottom = ((imageWrap.dataset.height / imageWrap.dataset.width) * 100) + '%';
	}

}
